import { combineReducers } from 'redux';

import common from './common/reducer';
import userAuth from './userAuth/reducer';
import fccCommon from './fccCommon/reducer';

export default combineReducers({
  common,
  userAuth,
  fccCommon,
});
